module.exports = __webpack_public_path__ + "img/logo-full.72d37bb2.svg";